import React from 'react';

const Eyebrow = ({ children }) => <span className="cy-eyebrow">{children}</span>;

const SectionHead = ({ eyebrow, title, lead, id, align = 'left', as: Tag = 'h2' }) => (
  <header
    className="cy-section-head"
    style={align === 'center' ? { textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' } : undefined}
  >
    {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
    {title ? <Tag className="cy-title">{title}</Tag> : null}
    {lead ? <p className="cy-lede">{lead}</p> : null}
  </header>
);

export { Eyebrow, SectionHead };
